import {Address} from "../../app/api/model/address";
import {getTranslation, TranslationContext} from "../getTranslationKey";
import {TFunction} from "i18next";
import {EMPTY_UI} from "../../variables";

export const getFormattedAddress = (t: TFunction, address?: Address) => {
    return address
        ? `${address.street} ${address.houseNumber} - ${address.city} ${address.postalCode} - ${getTranslation({
              context: TranslationContext.COUNTRY,
              value: address.country,
              t,
          })}`
        : EMPTY_UI;
};
